import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { toast } from 'sonner';
import { PageSpinner } from '@/components/LoadingBlock';
import { useAuth } from '@/lib/auth';

/**
 * Where the API sends the browser after a successful single sign-on. The refresh cookie is already set, so
 * the auth provider's boot refresh picks the session up; this page only waits for it and moves on.
 */
export function SsoCompletePage() {
  const { status } = useAuth();
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (status === 'loading') return;
    if (status === 'authenticated') {
      if (params.get('created') === '1') toast.success('Welcome! Your account was created from your organization sign-in.');
      const ret = params.get('return');
      navigate(ret && ret.startsWith('/') && !ret.startsWith('//') ? ret : '/jobs', { replace: true });
      return;
    }
    const slug = params.get('tenant');
    navigate(`/login${slug ? `/${encodeURIComponent(slug)}` : ''}?ssoError=${encodeURIComponent('The sign-in did not complete. Please try again.')}`, { replace: true });
  }, [status, params, navigate]);

  return <PageSpinner />;
}
